export default {
  loading: false,
  supervisor_departments: [],
  supervisor_department: {},
  totalCount: 0,
};
